// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useSignedUrl } from 'utilities/hooks';

// Components

const SignedUrlMedia = ({ url, type, className, title }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { signedUrl } = useSignedUrl(url);

    const isAllowedUrl = url =>
        url?.startsWith(
            'https://development-foundgood-files.s3.eu-west-1.amazonaws.com' ||
                'https://production-foundgood-files.s3.eu-west-1.amazonaws.com'
        );

    // ///////////////////
    // RETURN
    // ///////////////////

    return isAllowedUrl(url) ? (
        <>
            {type === 'image' && (
                <img
                    src={signedUrl}
                    className={className}
                    alt={title}
                    title={title}
                />
            )}

            {type === 'video' && (
                <video
                    src={signedUrl}
                    className={className}
                    controls
                    alt={title}
                    title={title}
                />
            )}
        </>
    ) : null;
};

SignedUrlMedia.propTypes = {
    url: t.string.isRequired,
    type: t.oneOf(['image', 'video']).isRequired,
    className: t.string,
    title: t.string,
};

SignedUrlMedia.defaultProps = {
    type: 'image',
    className: '',
    title: '',
};

export default SignedUrlMedia;
